<div class="centered">
  <div class="centered container">
    <img *ngIf="svg" [src]="svg" />
    <div *ngIf="placeholder" class="placeholder-text" [class.mobile]="rwdService.isSmallDevice">
      <h2 *ngIf="!noTitle">{{ 'empty.' + placeholder + 'Title' | loc }}</h2>
      <p>{{ 'empty.' + placeholder + 'Desc' | loc }}</p>
    </div>
  </div>
  <div *ngFor="let button of buttons" class="centered container empty-list">
    <div class="empty-list-add-wrapper">
      <button mat-button class="mat-button empty-list-add-button" [routerLink]="button.link">
        <mat-icon>add</mat-icon>{{ button.text | loc }}
      </button>
    </div>
  </div>
</div>
